module.exports = __webpack_public_path__ + "static/img/Round-01-2012.5d2203c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Round-01-2012.jpg
// module id = IkBP
// module chunks = 0